import JSEncrypt from 'jsencrypt'

// 加密函数
export function encryptData(data, publicKey) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey)
  return encryptor.encrypt(data)
}

// 生成密钥对（可选，通常后端提供公钥）
export function generateKeyPair() {
  const encryptor = new JSEncrypt({ default_key_size: 2048 })
  return {
    publicKey: encryptor.getPublicKey(),
    privateKey: encryptor.getPrivateKey()
  }
}